interface PaginationProps {
  current: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= totalPages; i += 1) pages.push(i);

  return (
    <nav className="flex items-center justify-center gap-2 mt-10" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className="w-9 h-9 rounded-md border border-background-700 text-foreground-200 flex items-center justify-center disabled:opacity-40 disabled:cursor-not-allowed hover:border-accent-600 hover:text-accent-400 transition-colors cursor-pointer"
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line" />
      </button>

      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          className={`min-w-9 h-9 px-3 rounded-md text-sm font-label transition-colors cursor-pointer ${
            page === current
              ? "bg-primary-600 text-background-50"
              : "border border-background-700 text-foreground-300 hover:border-accent-600 hover:text-accent-400"
          }`}
        >
          {page}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, current + 1))}
        disabled={current === totalPages}
        className="w-9 h-9 rounded-md border border-background-700 text-foreground-200 flex items-center justify-center disabled:opacity-40 disabled:cursor-not-allowed hover:border-accent-600 hover:text-accent-400 transition-colors cursor-pointer"
        aria-label="下一页"
      >
        <i className="ri-arrow-right-s-line" />
      </button>
    </nav>
  );
}